module.exports = __webpack_public_path__ + "img/category-brand-hover.207f2f60.png";